__turbopack_context__.v({
  "heading": "Calculator-module-scss-module__VyVuaG__heading",
});
